"use client";

import type { PropsWithChildren } from "react";
import ThemeRegistry from "@/lib/theme/ThemeRegistry";
import I18nProvider from "@/components/providers/I18nProvider";
import LocaleAttributesClient from "@/components/system/LocaleAttributesClient";
import ThemeColorMetaClient from "@/components/system/ThemeColorMetaClient";
import AppThemeProvider from "@/components/providers/AppThemeProvider";
import WebVitalsReporter from "@/client/components/WebVitalsReporter";

type ProvidersProps = PropsWithChildren<{
  locale: string;
}>;

const Providers: React.FC<ProvidersProps> = ({ locale, children }) => {
  return (
    <ThemeRegistry>
      <I18nProvider locale={locale}>
        <LocaleAttributesClient locale={locale} />
        <ThemeColorMetaClient />
        <AppThemeProvider>
          <WebVitalsReporter />
          {children}
        </AppThemeProvider>
      </I18nProvider>
    </ThemeRegistry>
  );
};

export default Providers;
